module.exports = __webpack_public_path__ + "img/adn.20928b48.svg";